var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenrateDashboardIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_434_825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66683 5.33337H12.0002C12.3538 5.33337 12.6929 5.47385 12.943 5.7239C13.193 5.97395 13.3335 6.31309 13.3335 6.66671V14.6667C13.3335 15.0203 13.193 15.3595 12.943 15.6095C12.6929 15.8596 12.3538 16 12.0002 16H6.66683C6.31321 16 5.97407 15.8596 5.72402 15.6095C5.47397 15.3595 5.3335 15.0203 5.3335 14.6667V6.66671C5.3335 6.31309 5.47397 5.97395 5.72402 5.7239C5.97407 5.47385 6.31321 5.33337 6.66683 5.33337Z",
    stroke: "#0B51C5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66683 21.3334H12.0002C12.3538 21.3334 12.6929 21.4738 12.943 21.7239C13.193 21.9739 13.3335 22.3131 13.3335 22.6667V25.3334C13.3335 25.687 13.193 26.0261 12.943 26.2762C12.6929 26.5262 12.3538 26.6667 12.0002 26.6667H6.66683C6.31321 26.6667 5.97407 26.5262 5.72402 26.2762C5.47397 26.0261 5.3335 25.687 5.3335 25.3334V22.6667C5.3335 22.3131 5.47397 21.9739 5.72402 21.7239C5.97407 21.4738 6.31321 21.3334 6.66683 21.3334Z",
    stroke: "#0B51C5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 16H25.3332C25.6868 16 26.0259 16.1405 26.276 16.3905C26.526 16.6406 26.6665 16.9797 26.6665 17.3333V25.3333C26.6665 25.687 26.526 26.0261 26.276 26.2761C26.0259 26.5262 25.6868 26.6667 25.3332 26.6667H19.9998C19.6462 26.6667 19.3071 26.5262 19.057 26.2761C18.807 26.0261 18.6665 25.687 18.6665 25.3333V17.3333C18.6665 16.9797 18.807 16.6406 19.057 16.3905C19.3071 16.1405 19.6462 16 19.9998 16Z",
    stroke: "#0B51C5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 5.33337H25.3332C25.6868 5.33337 26.0259 5.47385 26.276 5.7239C26.526 5.97395 26.6665 6.31309 26.6665 6.66671V9.33337C26.6665 9.687 26.526 10.0261 26.276 10.2762C26.0259 10.5262 25.6868 10.6667 25.3332 10.6667H19.9998C19.6462 10.6667 19.3071 10.5262 19.057 10.2762C18.807 10.0261 18.6665 9.687 18.6665 9.33337V6.66671C18.6665 6.31309 18.807 5.97395 19.057 5.7239C19.3071 5.47385 19.6462 5.33337 19.9998 5.33337Z",
    stroke: "#0B51C5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_434_825"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenrateDashboardIcon);
export default __webpack_public_path__ + "static/media/genrate_dashboard_icon.2522c0f13dc31b729b641819cb1e80af.svg";
export { ForwardRef as ReactComponent };